//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data () {
        return {
            loading: false,
            showStarsModal: false,
            showTextModal: false,
            activeSurprise: {}
        };
    },

    computed: {
        surprises () {
            return this.$store.getters.surprises.map((surprise, index) => ({
                ...surprise,
                active: this.$store.getters.isDayUnlocked(surprise.week, surprise.day),
                hasUser: this.$store.getters.hasUserSurprise(surprise.week, surprise.day),
                x: 480 + (index % 5 * 130),
                y: 180 + (Math.floor(index / 5) * 130)
            }));
        },
        nickname () {
            return this.$store.getters.nickname;
        },
        hasUserUnopenedSurprise () {
            return this.$store.getters.hasUserUnopenedSurprise;
        },
        allSurprisesOpened () {
            return this.surprises.filter(suprise => suprise.hasUser).length === this.surprises.length;
        },
        isNextUnopenedOnAMonday () {
            let nextSurprise = this.surprises.find(surprise => !surprise.active && !surprise.hasUser);

            return nextSurprise && nextSurprise.day === 1 ? true : false;
        }
    },

    methods: {
        async show (surprise) {
            if (!surprise.hasUser) {
                await this.getSurprise(surprise);
            }

            this.activeSurprise = surprise;
            if (this.activeSurprise.type === 'stars') {
                this.showStarsModal = true;
            }

            if (this.activeSurprise.type === 'text') {
                this.showTextModal = true;
            }
        },
        getSurprise (surprise) {
            return new Promise((resolve, reject) => {
                axios.post('game/surprise', {
                    week: surprise.week,
                    day: surprise.day,
                    value: surprise.type === 'stars' ? 2 : null
                }).then(response => {
                    this.$store.commit('storeGameData', response.data.data);
                    this.loading = false;
                    resolve();
                }).catch(() => {
                    this.loading = false;
                    reject();
                });
            });
        }
    }
};
